import { memo, useCallback, useMemo } from 'react';
import { SidebarBoxKey } from 'AdmissionsGuidance/StudentDashboard.types';
import { useTranslation } from 'react-i18next';
import { useCurrentUser, useNavigationHelper } from 'FrontRoyalAngular';
import { useSyncConfig } from 'FrontRoyalConfig';
import { targetBrandConfig } from 'AppBranding';
import { getProgramApplication } from 'Users';
import { BasicMobileBox } from '../../BasicMobileBox';
import { ImportantCtaBox } from '../../ImportantCtaBox';

function PreRecordedInterviewBoxComponent({ mobile }: { mobile?: boolean }) {
    const { loadUrl } = useNavigationHelper();
    const appConfig = useSyncConfig();
    const currentUser = useCurrentUser();
    const programApplication = useMemo(() => (currentUser ? getProgramApplication(currentUser) : null), [currentUser]);
    const interviewUrl = useMemo(() => {
        if (!programApplication) return null;
        if (programApplication.willoInviteLink) return programApplication.willoInviteLink;
        if (!currentUser) return null;
        const branding = targetBrandConfig(currentUser).branding;
        return appConfig.preRecordedInterviewUrls()[branding];
    }, [appConfig, currentUser, programApplication]);
    const onPressCta = useCallback(() => {
        if (!interviewUrl) return;
        loadUrl(interviewUrl, '_blank');
    }, [loadUrl, interviewUrl]);
    return mobile ? (
        <PreRecordedInterviewBoxMobilePresentation onPressCta={onPressCta} />
    ) : (
        <PreRecordedInterviewBoxPresentation onPressCta={onPressCta} />
    );
}

function PreRecordedInterviewBoxPresentation({ onPressCta }: { onPressCta: () => void }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'preRecordedInterviewBox' });
    return (
        <ImportantCtaBox
            headerTitle={t('headerTitle')}
            headerSubtitle={t('headerSubtitle')}
            boxKey={SidebarBoxKey.pre_recorded_interview}
            ctaText={t('ctaText')!}
            onPressCta={onPressCta}
        >
            {t('content')}
        </ImportantCtaBox>
    );
}

function PreRecordedInterviewBoxMobilePresentation({ onPressCta }: { onPressCta: () => void }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'preRecordedInterviewBox' });
    return (
        <BasicMobileBox
            heading={t('mobileContent')}
            boxKey={SidebarBoxKey.pre_recorded_interview}
            buttonId="cta"
            ctaText={t('mobileCtaText')!}
            onPress={onPressCta}
        />
    );
}

export const PreRecordedInterviewBox = memo(PreRecordedInterviewBoxComponent);
